export const BellIcon = (props) => (
  <svg
    width={20}
    height={20}
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      d='m18.274 16.87-1.43-2.386a7.1 7.1 0 0 1-1.01-3.645V8.75a5.84 5.84 0 0 0-4.168-5.587V1.666a1.667 1.667 0 0 0-3.333.001v1.496A5.84 5.84 0 0 0 4.166 8.75v2.09a7.1 7.1 0 0 1-1.009 3.643l-1.43 2.385a.416.416 0 0 0 .356.632h15.833a.418.418 0 0 0 .358-.63M7.376 18.332A2.91 2.91 0 0 0 10 19.999c1.16 0 2.154-.685 2.624-1.667z'
      fill='currentColor'
    />
  </svg>
)
